import React, { useEffect, useState } from "react";
import Layouts from "../../components/Layouts";
import { Button, Divider, Modal, Space, Table, Tag, Input } from "antd";
import { getDirectusClient } from "../../lib/directus";
import Addproduct from "./components/Addproduct";
import Viewproduct from "./components/Viewproduct";
import Editproduct from "./components/Editproduct";
import { deleteItem, readItems } from "@directus/sdk";
import { getProductos, getProductosCount, getProductosByNombre, getProductosCountByNombre } from "../../services/productos";
import { useSelector } from "react-redux";
import { formatPrice } from "../../lib/utils";

function Products(props) {
  const signoMoneda = useSelector((state) => state.signoMoneda.signo_moneda);
  const [data, setData] = useState([]);
  const [openadd, setOpenadd] = useState(false);
  const [openview, setOpenview] = useState(false);
  const [productselect, setProductselect] = useState({});
  const [openedit, setOpenedit] = useState(false);
  const [searchNombre, setSearchNombre] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });

  const addModal = () => {
    openadd ? setOpenadd(false) : setOpenadd(true);
  };

  const viewModal = () => {
    openview ? setOpenview(false) : setOpenview(true);
  };

  const editModal = () => {
    openedit ? setOpenedit(false) : setOpenedit(true);
  };

  const handleSearch = (value) => {
    setSearchNombre(value);
    setPagination(prev => ({ ...prev, current: 1 }));
    getProducts(value, 1, pagination.pageSize);
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    getProducts(searchNombre, pagination.current, pagination.pageSize);
  };

  const columns = [
    {
      title: "Codigo/Referencia",
      dataIndex: "referencia",
      key: "referencia",
    },
    {
      title: "Producto",
      dataIndex: "nombre",
      key: "age",
    },
    {
      title: "Precio",
      dataIndex: "preciosinimp",
      key: "preciosinimp",
      render: (text) => formatPrice(text, signoMoneda),
    },
    {
      title: "Grupo",
      key: "grupos",
      dataIndex: "grupos",
    },
    {
      title: "Estado",
      key: "estados",
      dataIndex: "estados",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <a
            onClick={() => {
              setProductselect(record);
              viewModal();
            }}
          >
            ver {record.name}
          </a>
          <a
            onClick={() => {
              setProductselect(record);
              editModal();
            }}
          >
            Editar
          </a>
          <a
            onClick={() => {
              Modal.confirm({
                content: "¿Estas seguro de eliminar este producto?",
                onOk: () => {
                  deleteProduct(record.id);
                },
              });
            }}
          >
            Eliminar
          </a>
        </Space>
      ),
    },
  ];

  const getProducts = async (nombre = "", page = 1, pageSize = 10) => {
    try {
      let productos;
      let countResponse;

      if (nombre) {
        productos = await getProductosByNombre(nombre, page, pageSize);
        countResponse = await getProductosCountByNombre(nombre);
      } else {
        productos = await getProductos();
        countResponse = await getProductosCount();
      }

      const total = parseInt(countResponse[0]?.countDistinct?.id || 0);

      productos.map((d) => {
        d.key = d.id;
        d.grupos = d.grupo?.nombre;
        d.estados = d.estado?.nombre;
      });

      setData(productos);
      setPagination(prev => ({
        ...prev,
        total: total
      }));
    } catch (error) {
      console.error("Error fetching products:", error);
      Modal.error({
        title: 'Error',
        content: 'Error al cargar los productos'
      });
    }
  };

  const deleteProduct = async (id) => {
    const directus = await getDirectusClient();
    directus
      .request(deleteItem("productos", id))
      .then((res) => {
        getProducts(searchNombre, pagination.current, pagination.pageSize);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getProducts("", pagination.current, pagination.pageSize);
  }, []);

  return (
    <Layouts>
      <Space direction="vertical" style={{ display: "flex" }}>
        <Space>
          <Button onClick={() => addModal()}>Nuevo producto</Button>
          <Input.Search
            placeholder="Buscar por nombre"
            allowClear
            onSearch={handleSearch}
            style={{ width: 300 }}
          />
        </Space>
        <Editproduct
          openedit={openedit}
          editModal={editModal}
          productselect={productselect}
          getProducts={getProducts}
        />
        <Viewproduct
          close={viewModal}
          open={openview}
          productselect={productselect}
        />
        <Addproduct
          openadd={openadd}
          addModal={addModal}
          getProducts={getProducts}
        />
        <Divider />
        <Table 
          columns={columns} 
          dataSource={data} 
          pagination={pagination}
          onChange={handleTableChange}
        />
      </Space>
    </Layouts>
  );
}

export default Products;
